import { createUseStyles } from 'react-jss'
import { transitionShort } from '../../../../styles/const/common'
import { trafficRedDark } from '../../../../styles/const/colors'

export default createUseStyles({
  closeBtn: {
    width: 10,
    height: 10,
    padding: 0,
    fontSize: 0,
    outline: 'none',
    backgroundColor: 'white',
    cursor: 'pointer',
    border: {
      width: 0
    },
    '&:hover path': {
      fill: trafficRedDark
    },
    '& path': {
      transition: transitionShort
    }
  }
})
